'use strict';


// public interface
module.exports = {
    onSettingsInit: function ( config, callback ) {
        require('mag-gettext').load({
            name: core.environment.language,
            path: config.path + 'lang'
        }, function () {
            var gettext = require('mag-gettext').gettext,
                sections = [
                    {
                        id: 'system',
                        icon: 'theme-icon-settings',
                        name: gettext('System'),
                        description: gettext('System Settings'),
                        saveImmediate: true
                    },
                    {
                        id: 'network',
                        name: gettext('Network'),
                        description: gettext('Configuring network connection settings'),
                        icon: 'theme-icon-lan'
                    }
                ];

            if ( window.core.device.model !== 'emulator' ) {
                sections.push({
                    id: 'video',
                    name: gettext('Video'),
                    description: gettext('Adjust video display settings'),
                    icon: 'theme-icon-monitor'
                });
            }

            callback(null, {
                id: 'system',
                name: 'system section',
                description: 'system section general description',
                sections: sections
            });
        });
    }
};
